module.exports = __webpack_public_path__ + "media/images/icons/image-383a68e5121e5a91d48b4dc811f06f49.svg";